import { combineReducers } from 'redux';
import User from './user';
import Ins from './ins';
import Edit from './edit';
import Works from './works';
import Resource from './resource';
import Record from './record';
import Plan from './plan';
import Welcome from './welcome';
import datacenter from './datacenter';
import Talent from './talent';
import Mlog from './mlog';
import Mv from './mv';
import musicBgVideo from './musicBgVideo';

export default combineReducers({
    User,
    Ins,
    Edit,
    Works,
    Resource,
    Record,
    Plan,
    Welcome,
    datacenter,
    Talent,
    Mlog,
    Mv,
    musicBgVideo
});



// WEBPACK FOOTER //
// ./client/reducers/index.js